import { render, staticRenderFns } from "./class-card.vue?vue&type=template&id=c3e9455a&scoped=true"
import script from "./class-card.vue?vue&type=script&lang=js"
export * from "./class-card.vue?vue&type=script&lang=js"
import style0 from "./class-card.vue?vue&type=style&index=0&id=c3e9455a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e9455a",
  null
  
)

export default component.exports